module.exports = __webpack_public_path__ + "img/brand (40).5a25820b.png";